<template>
  <PillBrowserLink
    :text="$t('copy.homePage.mainLayout.usefulLinks.links.gettingAround')"
    :url="$t('copy.homePage.mainLayout.usefulLinks.links.mapLink')"
    firebase-event-name="gensapp-home-view-map"
    data-event-tracking="gensapp-home-view-map"
    window-target="_self"
  />
</template>

<script>
import PillBrowserLink from './PillBrowserLink.vue';

export default {
  name: 'MapSection',
  components: { PillBrowserLink },
};
</script>
